import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Table from "components/Notifications/Notifications";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";

import {
  getNotifications,
  readAllNotifications,
  readNotification,
} from "store/actions/profile";

const Notifications = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth.authData);
  const notificationsData = useSelector(
    (state) => state.notifications.notifications
  );
  const [page, setPage] = useState(
    notificationsData ? notificationsData.pag.page : 1
  );
  const [amount, setAmount] = useState(
    notificationsData ? notificationsData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    notificationsData ? notificationsData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    notificationsData ? notificationsData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    notificationsData ? notificationsData.pag.search_by : "title"
  );

  useEffect(() => {
    dispatch(
      getNotifications(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  const readAllHandler = () => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(readAllNotifications(pag, history));
  };
  const readHandler = (id, item_id, type) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(readNotification(id, pag, history));
    if (type === 1) {
      history.push(`/admin/users/clients/${item_id}`);
    } else if (type === 2) {
      history.push(`/admin/recycables/show/${item_id}`);
    } else if (type === 3) {
      history.push(`/admin/branches/collected/${item_id}`);
    } else if (type === 4) {
      history.push(`/admin/vouchers/show/${item_id}`);
    } else if (type === 5) {
      history.push(`/admin/transactions/waiting-transactions`);
    } else if (type === 6) {
      if (authData.role === "admin") {
        history.push(`/admin/archived-batches/item/${item_id}`);
      } else if (authData.role === "manager") {
        history.push(`/admin/recycables/archived-items/${item_id}`);
      } else if (authData.role === "recycler") {
        history.push(`/admin/recycler/batch-items/${item_id}`);
      }
    }
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Notifications Table</h4>
        </CardHeader>
        <CardBody>
          {notificationsData && (
            <Table
              rows={notificationsData.data}
              totalRows={notificationsData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              //
              readAllHandler={readAllHandler}
              readHandler={readHandler}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Notifications;
